import { deleteDocumento, getDocumentosLista } from "../../services/DocumentosServices";
import { DocumentosContext } from "./DocumentosContext"

export const DocumentosState = ({ children }) => {
    const getDocumentosListaData = async () => {
        let res = await getDocumentosLista()
        return res
    }

    const deleteDocumentoData = async (body) => {
        const res = await deleteDocumento(body)
        if (res) getDocumentosListaData()
        return res
    }

    return <DocumentosContext.Provider value={{
        deleteDocumentoData,
        getDocumentosListaData
    }} >
        {children}
    </DocumentosContext.Provider>
}